import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  profileCard: css`
    margin-bottom: 20px;
    width: 100%;
    height: 112px;

    > div {
      width: 100%;
    }

    @media (min-width: 640px) {
      display: flex;
      align-items: center;
    }
  `,

  itemsCard: css`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
  `,

  avatarCard: css`
    display: none;
    width: 48px;
    height: 48px;
    align-items: center;
    justify-content: center;

    @media (min-width: 640px) {
      display: flex;
    }
  `,

  textCard: css`
    display: flex;
    flex-direction: column;
    margin-left: 24px;
    align-items: flex-start;
    flex-grow: 1;
    justify-content: center;
    align-items: center;
  `,

  nameCard: ({ colors, fontSizes }) => css`
    color: ${colors.brand.primary[300]};
    font-size: ${fontSizes.lg};
    display: inline-block;
  `,

  clinicCard: ({ colors }) => css`
    display: flex;
    color: ${colors.neutral[300]};
  `,

  boxPerfil: ({ colors }) => css`
    display: flex;
    color: ${colors.neutral[300]};
  `,

  detailsCard: ({ colors, fontSizes }) => css`
    color: ${colors.brand.primary[300]};
    p {
      font-size: ${fontSizes.sm};
      text-decoration: underline;
    }
  `,

  iconCard: ({ spacing }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    @media (max-width: 639px) {
      margin-left: ${spacing.xxs};
    }
  `,
})

export default useStyles
